import React, { useState, useRef } from 'react';
import { prop, pick } from 'ramda';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { BackboneReplacer } from '@core/js/backbone/components/BackboneReplacer';
import { Balance } from '@core/js/components/main/Balance/Balance';
import { useTranslations } from '@core/js/hooks/i18n';
import { useFormatter } from '@theme/js/hooks/useFormatter/useFormatter';

import style from './index.scss';
import useClickOutside from '@theme/js/components/common/Popup/hooks/useClickOutside';
import { TBalanceType } from '@core/js/components/main/Balance/types';

export const BalanceBreakdownPopup = () => {
    const headerHeight = useAppSelector(prop('headerHeight'));
    const depositLink = useAppSelector<string>(prop('depositPage'));
    const t = useTranslations('playtech.mobile.system.');

    const [isActive, setIsActive] = useState(false);
    const popupContainer = useRef<HTMLDivElement>(null);
    const breakdownContainer = useRef<HTMLDivElement>(null);
    const formatter = useFormatter();
    const { balance } = useUserSelector(pick(['balance']));
    const handleClose = () => {
        setIsActive(false);
    };

    useClickOutside(isActive, handleClose, false, breakdownContainer);

    const handleBreakdownClick = ({ target }: React.MouseEvent) => {
        if (!popupContainer.current?.contains(target as Node)) {
            setIsActive(active => {
                return !active;
            });
        }
    };

    const popupStyles = {
        display: isActive ? 'flex' : 'none',
        top: `${headerHeight}px`
    };

    const balances = [
        'casino_gaming_balance',
        'withdrawable_balance',
        'total_bonus_balance',
        'free_spin_balance'
    ];

    return (
        balance ? (<>
            <a className={style.depositButton} href={depositLink}>{t('deposit')}</a>
            <div className={style.container} onClick={handleBreakdownClick} ref={breakdownContainer}>
                <span className={style.totalAmount}>
                    {formatter.getRoundingBalance(balance.totalAmount)}
                </span>
                <div className={style.arrowDownContainer}>
                    <div className={`${style.arrowDown} ${isActive ? style.active : ''}`} />
                </div>
                <div className={style.popupContainer} style={popupStyles} ref={popupContainer}>
                    <div className={style.popupHeader}>{t('balance.casino')}</div>
                    <div className={style.popupBody}>
                        {
                            balances.map(value => {
                                return (
                                    <div key={value} className={style.balanceContainer}>
                                        <div>{t(`balance.${value}`)}</div>
                                        <Balance type={value as TBalanceType} />
                                    </div>
                                );
                            })
                        }
                        <div className={style.balanceContainer}>
                            <div>{t('balance.total_golden_chips_balance')}</div>
                            <BackboneReplacer dynamicName={'TOTAL_GOLDEN_CHIPS_BALANCE'} viewName={'totalgoldenchipsbalance'} />
                        </div>
                        <div className={style.popupButton} onClick={handleClose}>
                            <BackboneReplacer dynamicName={'HEADER_DEPOSIT_BUTTON'} viewName={'headerdepositbutton'} />
                        </div>
                    </div>
                </div>
            </div>
        </>) : null
    );
};
